// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import './styles.css'

import phoneIcon from '../Assets/icon_1.png'
import cardIcon from '../Assets/icon_2.png'
import sendColonIcon from '../Assets/icon_3.png'
import appStoreApple from '../Assets/appstore_apple.png'
import appStoreGoogle from '../Assets/appstore_google.png'

export default class SendMoneyNoWink extends Component {
    render() {
        return (
            <Grid fluid>
                <Row center="sm">
                    <Col xs={12} sm={12} md={12} lg={8}>
                        <div className='mainContainer'>
                            <Row center="xs">
                                <Col >
                                    <div className='winkTopLogo'></div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='holaText'>¡Hola!</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='whoMessage'>Iván Alarcón te ha enviado</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='amountText'>₡150.000</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='whoMessage'>a través de Wink</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} md={6}>
                                    <hr className='line' />
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <div className='transferMessage'>Mae, te devuelvo la plata que me habías prestado.</div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} md={6} >
                                    <hr className='line' />
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col className='signUpProcessIcons' xs={12} sm={3} md={3} >
                                    <img alt src={phoneIcon} />
                                    <div className='singUpProcessText'>1) Descargá Wink</div>
                                </Col>
                                <Col className='signUpProcessIcons' xs={12} sm={3} md={3} >
                                    <br />
                                    <img src={cardIcon} />
                                    <div className='singUpProcessText'>2) Registrate</div>
                                </Col>
                                <Col className='signUpProcessIcons' xs={12} sm={3} md={3} >
                                    <br />
                                    <img src={sendColonIcon} />
                                    <div className='singUpProcessText'>3) Recibí el dinero</div>
                                </Col>
                            </Row>
                            <Row className='signUpProcessIcons' center="xs">
                                <Col xs={12} sm={12} md={12} lg={4}>
                                    <a href='#'>
                                        <img src={appStoreApple} />
                                    </a>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={4}>
                                    <a href='#'>
                                        <img src={appStoreGoogle} />
                                    </a>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} md={12}>
                                    <div className='accreditText'>ó <a href='#'>acreditalo a una cuenta bancaria.</a></div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} md={12}>
                                    <div className='warningMessage'>El dinero estará disponible por 48 a partir del momento en que recibís este correo. <br />
                                        Después de este periodo, la transferencia no se podrá concretar.</div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/SendMoneyNoWink/index.js